
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompleteAccountDraftRequest,
  CreateAccountDraftRequest,
  DailyRateStatRequest,
  DailyRateStatResource,
  EducationContentRequest,
  FinishWorkflow200Response,
  FinishWorkflowRequest,
  FreelancerSignupFunctionalError,
  FreelancerSignupWorkflow,
  InitWorkflowRequest,
  RepatriationMetadata,
  SimpleError,
  SocialLoginRequest,
  StrategyBackground,
  UpdateCategoriesRequest,
  UpdateDailyRateRequest,
  UpdateExperienceLevelRequest,
  UpdateFreelancingExperienceRequest,
  UpdateHeadlineRequest,
  UpdateIndustryExpertisesRequest,
  UpdateLanguagesRequest,
  UpdateLocationAndWorkplaceRequest,
  UpdateOtherCategoryRequest,
  UpdatePhoneNumberRequest,
  UpdatePrivacyRequest,
  UpdateRegularSkillsRequest,
  UpdateSignupFamiliesAndCategoriesRequest,
  UpdateStrategySkillsRequest,
  UpdateWorkflowContextRequest,
  ValidateEmailValidationCodeRequest,
  ValidateWorkflowOwnershipRequest,
  VerifyEmailRequest,
  WorkExperienceContentRequest,
  WorkflowOwnershipValidationCodeRequest,
} from '../models';
import {
    CompleteAccountDraftRequestFromJSON,
    CompleteAccountDraftRequestToJSON,
    CreateAccountDraftRequestFromJSON,
    CreateAccountDraftRequestToJSON,
    DailyRateStatRequestFromJSON,
    DailyRateStatRequestToJSON,
    DailyRateStatResourceFromJSON,
    DailyRateStatResourceToJSON,
    EducationContentRequestFromJSON,
    EducationContentRequestToJSON,
    FinishWorkflow200ResponseFromJSON,
    FinishWorkflow200ResponseToJSON,
    FinishWorkflowRequestFromJSON,
    FinishWorkflowRequestToJSON,
    FreelancerSignupFunctionalErrorFromJSON,
    FreelancerSignupFunctionalErrorToJSON,
    FreelancerSignupWorkflowFromJSON,
    FreelancerSignupWorkflowToJSON,
    InitWorkflowRequestFromJSON,
    InitWorkflowRequestToJSON,
    RepatriationMetadataFromJSON,
    RepatriationMetadataToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
    SocialLoginRequestFromJSON,
    SocialLoginRequestToJSON,
    StrategyBackgroundFromJSON,
    StrategyBackgroundToJSON,
    UpdateCategoriesRequestFromJSON,
    UpdateCategoriesRequestToJSON,
    UpdateDailyRateRequestFromJSON,
    UpdateDailyRateRequestToJSON,
    UpdateExperienceLevelRequestFromJSON,
    UpdateExperienceLevelRequestToJSON,
    UpdateFreelancingExperienceRequestFromJSON,
    UpdateFreelancingExperienceRequestToJSON,
    UpdateHeadlineRequestFromJSON,
    UpdateHeadlineRequestToJSON,
    UpdateIndustryExpertisesRequestFromJSON,
    UpdateIndustryExpertisesRequestToJSON,
    UpdateLanguagesRequestFromJSON,
    UpdateLanguagesRequestToJSON,
    UpdateLocationAndWorkplaceRequestFromJSON,
    UpdateLocationAndWorkplaceRequestToJSON,
    UpdateOtherCategoryRequestFromJSON,
    UpdateOtherCategoryRequestToJSON,
    UpdatePhoneNumberRequestFromJSON,
    UpdatePhoneNumberRequestToJSON,
    UpdatePrivacyRequestFromJSON,
    UpdatePrivacyRequestToJSON,
    UpdateRegularSkillsRequestFromJSON,
    UpdateRegularSkillsRequestToJSON,
    UpdateSignupFamiliesAndCategoriesRequestFromJSON,
    UpdateSignupFamiliesAndCategoriesRequestToJSON,
    UpdateStrategySkillsRequestFromJSON,
    UpdateStrategySkillsRequestToJSON,
    UpdateWorkflowContextRequestFromJSON,
    UpdateWorkflowContextRequestToJSON,
    ValidateEmailValidationCodeRequestFromJSON,
    ValidateEmailValidationCodeRequestToJSON,
    ValidateWorkflowOwnershipRequestFromJSON,
    ValidateWorkflowOwnershipRequestToJSON,
    VerifyEmailRequestFromJSON,
    VerifyEmailRequestToJSON,
    WorkExperienceContentRequestFromJSON,
    WorkExperienceContentRequestToJSON,
    WorkflowOwnershipValidationCodeRequestFromJSON,
    WorkflowOwnershipValidationCodeRequestToJSON,
} from '../models';

export interface AddEducationRequest {
    educationContentRequest: EducationContentRequest;
}

export interface AddWorkExperienceRequest {
    workExperienceContentRequest: WorkExperienceContentRequest;
}

export interface AskWorkflowOwnershipValidationCodeRequest {
    workflowOwnershipValidationCodeRequest: WorkflowOwnershipValidationCodeRequest;
}

export interface AssociateWorkflowByReminderToUserRequest {
    reminderUuid: string;
}

export interface CompleteAccountDraftOperationRequest {
    completeAccountDraftRequest: CompleteAccountDraftRequest;
}

export interface CreateAccountDraftOperationRequest {
    createAccountDraftRequest: CreateAccountDraftRequest;
}

export interface CreateAccountDraftFromSocialLoginRequest {
    socialLoginRequest: SocialLoginRequest;
}

export interface DeleteEducationRequest {
    educationId: string;
}

export interface DeleteWorkExperienceRequest {
    workExperienceId: string;
}

export interface FinishWorkflowOperationRequest {
    finishWorkflowRequest: FinishWorkflowRequest;
}

export interface GetAverageDailyRateAndFeesRequest {
    dailyRateStatRequest: DailyRateStatRequest;
}

export interface GetRepatriationMetadataRequest {
    repatriationTokenId: string;
}

export interface ImportResumeRequest {
    resume: Blob;
}

export interface InitWorkflowOperationRequest {
    initWorkflowRequest: InitWorkflowRequest;
}

export interface UpdateCategoriesOperationRequest {
    updateCategoriesRequest: UpdateCategoriesRequest;
}

export interface UpdateDailyRateOperationRequest {
    updateDailyRateRequest: UpdateDailyRateRequest;
}

export interface UpdateEducationRequest {
    educationId: string;
    educationContentRequest: EducationContentRequest;
}

export interface UpdateExperienceLevelOperationRequest {
    updateExperienceLevelRequest: UpdateExperienceLevelRequest;
}

export interface UpdateFreelancingExperienceOperationRequest {
    updateFreelancingExperienceRequest: UpdateFreelancingExperienceRequest;
}

export interface UpdateHeadlineOperationRequest {
    updateHeadlineRequest: UpdateHeadlineRequest;
}

export interface UpdateLanguagesOperationRequest {
    updateLanguagesRequest: UpdateLanguagesRequest;
}

export interface UpdateLocationAndWorkplaceOperationRequest {
    updateLocationAndWorkplaceRequest: UpdateLocationAndWorkplaceRequest;
}

export interface UpdateOtherCategoryOperationRequest {
    updateOtherCategoryRequest: UpdateOtherCategoryRequest;
}

export interface UpdatePhoneNumberOperationRequest {
    updatePhoneNumberRequest: UpdatePhoneNumberRequest;
}

export interface UpdatePrivacyOperationRequest {
    updatePrivacyRequest: UpdatePrivacyRequest;
}

export interface UpdateProfilePictureRequest {
    profilePicture: Blob;
}

export interface UpdateRegularSkillsOperationRequest {
    updateRegularSkillsRequest: UpdateRegularSkillsRequest;
}

export interface UpdateSignupFamiliesAndCategoriesOperationRequest {
    updateSignupFamiliesAndCategoriesRequest: UpdateSignupFamiliesAndCategoriesRequest;
}

export interface UpdateSignupIndustryExpertisesRequest {
    updateIndustryExpertisesRequest: UpdateIndustryExpertisesRequest;
}

export interface UpdateStrategyBackgroundRequest {
    strategyBackground: Array<StrategyBackground>;
}

export interface UpdateStrategySkillsOperationRequest {
    updateStrategySkillsRequest: UpdateStrategySkillsRequest;
}

export interface UpdateWorkExperienceRequest {
    workExperienceId: string;
    workExperienceContentRequest: WorkExperienceContentRequest;
}

export interface UpdateWorkflowContextOperationRequest {
    updateWorkflowContextRequest: UpdateWorkflowContextRequest;
}

export interface ValidateEmailValidationCodeOperationRequest {
    validateEmailValidationCodeRequest: ValidateEmailValidationCodeRequest;
}

export interface ValidateWorkflowOwnershipOperationRequest {
    validateWorkflowOwnershipRequest: ValidateWorkflowOwnershipRequest;
}

export interface VerifyEmailOperationRequest {
    verifyEmailRequest: VerifyEmailRequest;
}

/**
 * 
 */
export class FreelancerSignupApi extends runtime.BaseAPI {

    /**
     * Add an education
          */
    async addEducationRaw(requestParameters: AddEducationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['educationContentRequest'] == null) {
            throw new runtime.RequiredError(
                'educationContentRequest',
                'Required parameter "educationContentRequest" was null or undefined when calling addEducation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/educations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EducationContentRequestToJSON(requestParameters['educationContentRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Add an education
          */
    async addEducation(requestParameters: AddEducationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.addEducationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Add a work experience
          */
    async addWorkExperienceRaw(requestParameters: AddWorkExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['workExperienceContentRequest'] == null) {
            throw new runtime.RequiredError(
                'workExperienceContentRequest',
                'Required parameter "workExperienceContentRequest" was null or undefined when calling addWorkExperience().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/work-experiences`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkExperienceContentRequestToJSON(requestParameters['workExperienceContentRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Add a work experience
          */
    async addWorkExperience(requestParameters: AddWorkExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.addWorkExperienceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Ask for a new validation code for the email
          */
    async askNewEmailValidationCodeRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/account/draft/validation-code/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Ask for a new validation code for the email
          */
    async askNewEmailValidationCode(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.askNewEmailValidationCodeRaw(initOverrides);
        return response._data;
    }

    /**
     * Asks for a new validation code for the email to prove workflow ownership
          */
    async askWorkflowOwnershipValidationCodeRaw(requestParameters: AskWorkflowOwnershipValidationCodeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['workflowOwnershipValidationCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'workflowOwnershipValidationCodeRequest',
                'Required parameter "workflowOwnershipValidationCodeRequest" was null or undefined when calling askWorkflowOwnershipValidationCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/freelancer-signup/workflow-ownership/ask`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkflowOwnershipValidationCodeRequestToJSON(requestParameters['workflowOwnershipValidationCodeRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Asks for a new validation code for the email to prove workflow ownership
          */
    async askWorkflowOwnershipValidationCode(requestParameters: AskWorkflowOwnershipValidationCodeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.askWorkflowOwnershipValidationCodeRaw(requestParameters, initOverrides);
    }

    /**
     * Finds the freelancer signup workflow using the reminder uuid and then associate it to the current sessionId
          */
    async associateWorkflowByReminderToUserRaw(requestParameters: AssociateWorkflowByReminderToUserRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['reminderUuid'] == null) {
            throw new runtime.RequiredError(
                'reminderUuid',
                'Required parameter "reminderUuid" was null or undefined when calling associateWorkflowByReminderToUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/reminder/{reminderUuid}`.replace(`{${"reminderUuid"}}`, encodeURIComponent(String(requestParameters['reminderUuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Finds the freelancer signup workflow using the reminder uuid and then associate it to the current sessionId
          */
    async associateWorkflowByReminderToUser(requestParameters: AssociateWorkflowByReminderToUserRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.associateWorkflowByReminderToUserRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Complete an account draft created by the SSO
          */
    async completeAccountDraftRaw(requestParameters: CompleteAccountDraftOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['completeAccountDraftRequest'] == null) {
            throw new runtime.RequiredError(
                'completeAccountDraftRequest',
                'Required parameter "completeAccountDraftRequest" was null or undefined when calling completeAccountDraft().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/account/draft`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteAccountDraftRequestToJSON(requestParameters['completeAccountDraftRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Complete an account draft created by the SSO
          */
    async completeAccountDraft(requestParameters: CompleteAccountDraftOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.completeAccountDraftRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Creates an account draft
          */
    async createAccountDraftRaw(requestParameters: CreateAccountDraftOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['createAccountDraftRequest'] == null) {
            throw new runtime.RequiredError(
                'createAccountDraftRequest',
                'Required parameter "createAccountDraftRequest" was null or undefined when calling createAccountDraft().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/account/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAccountDraftRequestToJSON(requestParameters['createAccountDraftRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Creates an account draft
          */
    async createAccountDraft(requestParameters: CreateAccountDraftOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.createAccountDraftRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Creates an account draft after authenticating the user through social login
          */
    async createAccountDraftFromSocialLoginRaw(requestParameters: CreateAccountDraftFromSocialLoginRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['socialLoginRequest'] == null) {
            throw new runtime.RequiredError(
                'socialLoginRequest',
                'Required parameter "socialLoginRequest" was null or undefined when calling createAccountDraftFromSocialLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/account/sso`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SocialLoginRequestToJSON(requestParameters['socialLoginRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Creates an account draft after authenticating the user through social login
          */
    async createAccountDraftFromSocialLogin(requestParameters: CreateAccountDraftFromSocialLoginRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.createAccountDraftFromSocialLoginRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Deletes the account draft
          */
    async deleteAccountDraftRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/account/draft`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Deletes the account draft
          */
    async deleteAccountDraft(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.deleteAccountDraftRaw(initOverrides);
        return response._data;
    }

    /**
     * Delete an education
          */
    async deleteEducationRaw(requestParameters: DeleteEducationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['educationId'] == null) {
            throw new runtime.RequiredError(
                'educationId',
                'Required parameter "educationId" was null or undefined when calling deleteEducation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/educations/{educationId}`.replace(`{${"educationId"}}`, encodeURIComponent(String(requestParameters['educationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Delete an education
          */
    async deleteEducation(requestParameters: DeleteEducationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.deleteEducationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * deletes the profile picture
          */
    async deleteProfilePictureRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/picture`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * deletes the profile picture
          */
    async deleteProfilePicture(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.deleteProfilePictureRaw(initOverrides);
        return response._data;
    }

    /**
     * Delete a work experience
          */
    async deleteWorkExperienceRaw(requestParameters: DeleteWorkExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['workExperienceId'] == null) {
            throw new runtime.RequiredError(
                'workExperienceId',
                'Required parameter "workExperienceId" was null or undefined when calling deleteWorkExperience().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/work-experiences/{workExperienceId}`.replace(`{${"workExperienceId"}}`, encodeURIComponent(String(requestParameters['workExperienceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Delete a work experience
          */
    async deleteWorkExperience(requestParameters: DeleteWorkExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.deleteWorkExperienceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Finds the freelancer signup workflow, if it exists
          */
    async findWorkflowRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Finds the freelancer signup workflow, if it exists
          */
    async findWorkflow(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.findWorkflowRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async finishWorkflowRaw(requestParameters: FinishWorkflowOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FinishWorkflow200Response>> {
        if (requestParameters['finishWorkflowRequest'] == null) {
            throw new runtime.RequiredError(
                'finishWorkflowRequest',
                'Required parameter "finishWorkflowRequest" was null or undefined when calling finishWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FinishWorkflow200Response>({
            path: `/profile/api/freelancer-signup/finish`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinishWorkflowRequestToJSON(requestParameters['finishWorkflowRequest']),
        }, initOverrides);

        if (response._data) { response._data=FinishWorkflow200ResponseFromJSON(response._data); }
        return response;
    }

    /**
          */
    async finishWorkflow(requestParameters: FinishWorkflowOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FinishWorkflow200Response> {
        const response = await this.finishWorkflowRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Gives stats for daily rate
          */
    async getAverageDailyRateAndFeesRaw(requestParameters: GetAverageDailyRateAndFeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<DailyRateStatResource>> {
        if (requestParameters['dailyRateStatRequest'] == null) {
            throw new runtime.RequiredError(
                'dailyRateStatRequest',
                'Required parameter "dailyRateStatRequest" was null or undefined when calling getAverageDailyRateAndFees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<DailyRateStatResource>({
            path: `/profile/api/freelancer-signup/profile/daily-rate/stats`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DailyRateStatRequestToJSON(requestParameters['dailyRateStatRequest']),
        }, initOverrides);

        if (response._data) { response._data=DailyRateStatResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Gives stats for daily rate
          */
    async getAverageDailyRateAndFees(requestParameters: GetAverageDailyRateAndFeesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<DailyRateStatResource> {
        const response = await this.getAverageDailyRateAndFeesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Gets the repatriation metadata from the repatriation token id
          */
    async getRepatriationMetadataRaw(requestParameters: GetRepatriationMetadataRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RepatriationMetadata>> {
        if (requestParameters['repatriationTokenId'] == null) {
            throw new runtime.RequiredError(
                'repatriationTokenId',
                'Required parameter "repatriationTokenId" was null or undefined when calling getRepatriationMetadata().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<RepatriationMetadata>({
            path: `/profile/api/freelancer-signup/repatriation/{repatriationTokenId}/metadata`.replace(`{${"repatriationTokenId"}}`, encodeURIComponent(String(requestParameters['repatriationTokenId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=RepatriationMetadataFromJSON(response._data); }
        return response;
    }

    /**
     * Gets the repatriation metadata from the repatriation token id
          */
    async getRepatriationMetadata(requestParameters: GetRepatriationMetadataRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RepatriationMetadata> {
        const response = await this.getRepatriationMetadataRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Import resume to complete the profile
          */
    async importResumeRaw(requestParameters: ImportResumeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['resume'] == null) {
            throw new runtime.RequiredError(
                'resume',
                'Required parameter "resume" was null or undefined when calling importResume().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['resume'] != null) {
            formParams.append('resume', requestParameters['resume'] as any);
        }

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/resume-import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Import resume to complete the profile
          */
    async importResume(requestParameters: ImportResumeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.importResumeRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Initialize freelancer signup workflow
          */
    async initWorkflowRaw(requestParameters: InitWorkflowOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['initWorkflowRequest'] == null) {
            throw new runtime.RequiredError(
                'initWorkflowRequest',
                'Required parameter "initWorkflowRequest" was null or undefined when calling initWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitWorkflowRequestToJSON(requestParameters['initWorkflowRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Initialize freelancer signup workflow
          */
    async initWorkflow(requestParameters: InitWorkflowOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.initWorkflowRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * skip the phone number step
          */
    async skipPhoneNumberRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/phone-number`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * skip the phone number step
          */
    async skipPhoneNumber(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.skipPhoneNumberRaw(initOverrides);
        return response._data;
    }

    /**
     * skip the profile picture
          */
    async skipProfilePictureRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/picture/skip`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * skip the profile picture
          */
    async skipProfilePicture(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.skipProfilePictureRaw(initOverrides);
        return response._data;
    }

    /**
     * Skip the profile skills for a regular freelancer
          */
    async skipRegularSkillsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/regular/skills`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Skip the profile skills for a regular freelancer
          */
    async skipRegularSkills(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.skipRegularSkillsRaw(initOverrides);
        return response._data;
    }

    /**
     * Skip the resume import step
          */
    async skipResumeImportRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/resume-import`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Skip the resume import step
          */
    async skipResumeImport(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.skipResumeImportRaw(initOverrides);
        return response._data;
    }

    /**
     * Skip work experiences
          */
    async skipWorkExperiencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/work-experiences/skip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Skip work experiences
          */
    async skipWorkExperiences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.skipWorkExperiencesRaw(initOverrides);
        return response._data;
    }

    /**
     * Updates categories of the profile
          */
    async updateCategoriesRaw(requestParameters: UpdateCategoriesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateCategoriesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCategoriesRequest',
                'Required parameter "updateCategoriesRequest" was null or undefined when calling updateCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCategoriesRequestToJSON(requestParameters['updateCategoriesRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates categories of the profile
          */
    async updateCategories(requestParameters: UpdateCategoriesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateCategoriesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * updates daily rate
          */
    async updateDailyRateRaw(requestParameters: UpdateDailyRateOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateDailyRateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDailyRateRequest',
                'Required parameter "updateDailyRateRequest" was null or undefined when calling updateDailyRate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/daily-rate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDailyRateRequestToJSON(requestParameters['updateDailyRateRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * updates daily rate
          */
    async updateDailyRate(requestParameters: UpdateDailyRateOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateDailyRateRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update an education
          */
    async updateEducationRaw(requestParameters: UpdateEducationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['educationId'] == null) {
            throw new runtime.RequiredError(
                'educationId',
                'Required parameter "educationId" was null or undefined when calling updateEducation().'
            );
        }

        if (requestParameters['educationContentRequest'] == null) {
            throw new runtime.RequiredError(
                'educationContentRequest',
                'Required parameter "educationContentRequest" was null or undefined when calling updateEducation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/educations/{educationId}`.replace(`{${"educationId"}}`, encodeURIComponent(String(requestParameters['educationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EducationContentRequestToJSON(requestParameters['educationContentRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Update an education
          */
    async updateEducation(requestParameters: UpdateEducationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateEducationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates the experience level of the profile
          */
    async updateExperienceLevelRaw(requestParameters: UpdateExperienceLevelOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateExperienceLevelRequest'] == null) {
            throw new runtime.RequiredError(
                'updateExperienceLevelRequest',
                'Required parameter "updateExperienceLevelRequest" was null or undefined when calling updateExperienceLevel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/experience-level`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateExperienceLevelRequestToJSON(requestParameters['updateExperienceLevelRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates the experience level of the profile
          */
    async updateExperienceLevel(requestParameters: UpdateExperienceLevelOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateExperienceLevelRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates the freelancer\'s freelancing experience
          */
    async updateFreelancingExperienceRaw(requestParameters: UpdateFreelancingExperienceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateFreelancingExperienceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFreelancingExperienceRequest',
                'Required parameter "updateFreelancingExperienceRequest" was null or undefined when calling updateFreelancingExperience().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/freelancing-experience`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFreelancingExperienceRequestToJSON(requestParameters['updateFreelancingExperienceRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates the freelancer\'s freelancing experience
          */
    async updateFreelancingExperience(requestParameters: UpdateFreelancingExperienceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateFreelancingExperienceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates the headline of the profile
          */
    async updateHeadlineRaw(requestParameters: UpdateHeadlineOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateHeadlineRequest'] == null) {
            throw new runtime.RequiredError(
                'updateHeadlineRequest',
                'Required parameter "updateHeadlineRequest" was null or undefined when calling updateHeadline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/headline`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHeadlineRequestToJSON(requestParameters['updateHeadlineRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates the headline of the profile
          */
    async updateHeadline(requestParameters: UpdateHeadlineOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateHeadlineRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * updates languages
          */
    async updateLanguagesRaw(requestParameters: UpdateLanguagesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateLanguagesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLanguagesRequest',
                'Required parameter "updateLanguagesRequest" was null or undefined when calling updateLanguages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/languages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLanguagesRequestToJSON(requestParameters['updateLanguagesRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * updates languages
          */
    async updateLanguages(requestParameters: UpdateLanguagesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateLanguagesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * updates location and workplace
          */
    async updateLocationAndWorkplaceRaw(requestParameters: UpdateLocationAndWorkplaceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateLocationAndWorkplaceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationAndWorkplaceRequest',
                'Required parameter "updateLocationAndWorkplaceRequest" was null or undefined when calling updateLocationAndWorkplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/location-workplace`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationAndWorkplaceRequestToJSON(requestParameters['updateLocationAndWorkplaceRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * updates location and workplace
          */
    async updateLocationAndWorkplace(requestParameters: UpdateLocationAndWorkplaceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateLocationAndWorkplaceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates categories of the profile with a free text provided by freelancers
          */
    async updateOtherCategoryRaw(requestParameters: UpdateOtherCategoryOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateOtherCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOtherCategoryRequest',
                'Required parameter "updateOtherCategoryRequest" was null or undefined when calling updateOtherCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/other-category`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOtherCategoryRequestToJSON(requestParameters['updateOtherCategoryRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates categories of the profile with a free text provided by freelancers
          */
    async updateOtherCategory(requestParameters: UpdateOtherCategoryOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateOtherCategoryRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * updates the phone number
          */
    async updatePhoneNumberRaw(requestParameters: UpdatePhoneNumberOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updatePhoneNumberRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePhoneNumberRequest',
                'Required parameter "updatePhoneNumberRequest" was null or undefined when calling updatePhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/phone-number`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePhoneNumberRequestToJSON(requestParameters['updatePhoneNumberRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * updates the phone number
          */
    async updatePhoneNumber(requestParameters: UpdatePhoneNumberOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updatePhoneNumberRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * updates the privacy (opt out of being listed in search engines)
          */
    async updatePrivacyRaw(requestParameters: UpdatePrivacyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updatePrivacyRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePrivacyRequest',
                'Required parameter "updatePrivacyRequest" was null or undefined when calling updatePrivacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/privacy`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePrivacyRequestToJSON(requestParameters['updatePrivacyRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * updates the privacy (opt out of being listed in search engines)
          */
    async updatePrivacy(requestParameters: UpdatePrivacyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updatePrivacyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * updates the profile picture
          */
    async updateProfilePictureRaw(requestParameters: UpdateProfilePictureRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['profilePicture'] == null) {
            throw new runtime.RequiredError(
                'profilePicture',
                'Required parameter "profilePicture" was null or undefined when calling updateProfilePicture().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['profilePicture'] != null) {
            formParams.append('profilePicture', requestParameters['profilePicture'] as any);
        }

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/picture`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * updates the profile picture
          */
    async updateProfilePicture(requestParameters: UpdateProfilePictureRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateProfilePictureRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates the skills of the profile of the regular freelancer
          */
    async updateRegularSkillsRaw(requestParameters: UpdateRegularSkillsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateRegularSkillsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRegularSkillsRequest',
                'Required parameter "updateRegularSkillsRequest" was null or undefined when calling updateRegularSkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/regular/skills`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRegularSkillsRequestToJSON(requestParameters['updateRegularSkillsRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates the skills of the profile of the regular freelancer
          */
    async updateRegularSkills(requestParameters: UpdateRegularSkillsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateRegularSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates families and categories of the profile
          */
    async updateSignupFamiliesAndCategoriesRaw(requestParameters: UpdateSignupFamiliesAndCategoriesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateSignupFamiliesAndCategoriesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSignupFamiliesAndCategoriesRequest',
                'Required parameter "updateSignupFamiliesAndCategoriesRequest" was null or undefined when calling updateSignupFamiliesAndCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/families-and-categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSignupFamiliesAndCategoriesRequestToJSON(requestParameters['updateSignupFamiliesAndCategoriesRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates families and categories of the profile
          */
    async updateSignupFamiliesAndCategories(requestParameters: UpdateSignupFamiliesAndCategoriesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateSignupFamiliesAndCategoriesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates industry expertises of the profile
          */
    async updateSignupIndustryExpertisesRaw(requestParameters: UpdateSignupIndustryExpertisesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateIndustryExpertisesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIndustryExpertisesRequest',
                'Required parameter "updateIndustryExpertisesRequest" was null or undefined when calling updateSignupIndustryExpertises().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/industry-expertises`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIndustryExpertisesRequestToJSON(requestParameters['updateIndustryExpertisesRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates industry expertises of the profile
          */
    async updateSignupIndustryExpertises(requestParameters: UpdateSignupIndustryExpertisesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateSignupIndustryExpertisesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates strategy background of profile
          */
    async updateStrategyBackgroundRaw(requestParameters: UpdateStrategyBackgroundRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['strategyBackground'] == null) {
            throw new runtime.RequiredError(
                'strategyBackground',
                'Required parameter "strategyBackground" was null or undefined when calling updateStrategyBackground().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/strategy-background`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['strategyBackground']!.map(StrategyBackgroundToJSON),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates strategy background of profile
          */
    async updateStrategyBackground(requestParameters: UpdateStrategyBackgroundRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateStrategyBackgroundRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Updates the skills of the profile of the strategy freelancer, functional and global
          */
    async updateStrategySkillsRaw(requestParameters: UpdateStrategySkillsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateStrategySkillsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateStrategySkillsRequest',
                'Required parameter "updateStrategySkillsRequest" was null or undefined when calling updateStrategySkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/strategy/skills`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStrategySkillsRequestToJSON(requestParameters['updateStrategySkillsRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Updates the skills of the profile of the strategy freelancer, functional and global
          */
    async updateStrategySkills(requestParameters: UpdateStrategySkillsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateStrategySkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update a work experience
          */
    async updateWorkExperienceRaw(requestParameters: UpdateWorkExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['workExperienceId'] == null) {
            throw new runtime.RequiredError(
                'workExperienceId',
                'Required parameter "workExperienceId" was null or undefined when calling updateWorkExperience().'
            );
        }

        if (requestParameters['workExperienceContentRequest'] == null) {
            throw new runtime.RequiredError(
                'workExperienceContentRequest',
                'Required parameter "workExperienceContentRequest" was null or undefined when calling updateWorkExperience().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/work-experiences/{workExperienceId}`.replace(`{${"workExperienceId"}}`, encodeURIComponent(String(requestParameters['workExperienceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WorkExperienceContentRequestToJSON(requestParameters['workExperienceContentRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Update a work experience
          */
    async updateWorkExperience(requestParameters: UpdateWorkExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateWorkExperienceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Change context of the workflow
          */
    async updateWorkflowContextRaw(requestParameters: UpdateWorkflowContextOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['updateWorkflowContextRequest'] == null) {
            throw new runtime.RequiredError(
                'updateWorkflowContextRequest',
                'Required parameter "updateWorkflowContextRequest" was null or undefined when calling updateWorkflowContext().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWorkflowContextRequestToJSON(requestParameters['updateWorkflowContextRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Change context of the workflow
          */
    async updateWorkflowContext(requestParameters: UpdateWorkflowContextOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.updateWorkflowContextRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Validate all educations
          */
    async validateEducationsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/educations/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Validate all educations
          */
    async validateEducations(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.validateEducationsRaw(initOverrides);
        return response._data;
    }

    /**
     * Validates that the validation code for the email is correct
          */
    async validateEmailValidationCodeRaw(requestParameters: ValidateEmailValidationCodeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['validateEmailValidationCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'validateEmailValidationCodeRequest',
                'Required parameter "validateEmailValidationCodeRequest" was null or undefined when calling validateEmailValidationCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/account/draft/validation-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateEmailValidationCodeRequestToJSON(requestParameters['validateEmailValidationCodeRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Validates that the validation code for the email is correct
          */
    async validateEmailValidationCode(requestParameters: ValidateEmailValidationCodeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.validateEmailValidationCodeRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Validate work experiences
          */
    async validateWorkExperiencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/profile/work-experiences/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Validate work experiences
          */
    async validateWorkExperiences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.validateWorkExperiencesRaw(initOverrides);
        return response._data;
    }

    /**
     * Validates that the validation code for the email is correct and assigns the workflow to the current sessionId
          */
    async validateWorkflowOwnershipRaw(requestParameters: ValidateWorkflowOwnershipOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['validateWorkflowOwnershipRequest'] == null) {
            throw new runtime.RequiredError(
                'validateWorkflowOwnershipRequest',
                'Required parameter "validateWorkflowOwnershipRequest" was null or undefined when calling validateWorkflowOwnership().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/workflow-ownership/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateWorkflowOwnershipRequestToJSON(requestParameters['validateWorkflowOwnershipRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Validates that the validation code for the email is correct and assigns the workflow to the current sessionId
          */
    async validateWorkflowOwnership(requestParameters: ValidateWorkflowOwnershipOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.validateWorkflowOwnershipRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Verify email
          */
    async verifyEmailRaw(requestParameters: VerifyEmailOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerSignupWorkflow>> {
        if (requestParameters['verifyEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyEmailRequest',
                'Required parameter "verifyEmailRequest" was null or undefined when calling verifyEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerSignupWorkflow>({
            path: `/profile/api/freelancer-signup/verify-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyEmailRequestToJSON(requestParameters['verifyEmailRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerSignupWorkflowFromJSON(response._data); }
        return response;
    }

    /**
     * Verify email
          */
    async verifyEmail(requestParameters: VerifyEmailOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerSignupWorkflow> {
        const response = await this.verifyEmailRaw(requestParameters, initOverrides);
        return response._data;
    }

}
